export default __webpack_public_path__ + "static/media/eye-icon.6f024b65.svg";